import { convertSnakeToCamel } from "@/app/infrastructures/misc/common-library/ConvertSnakeToCamel";
import {
  CariSttEntities,
  ListCariSTT,
  DetailSttScan,
  DetailStt,
  SearchSttScan,
  SearchSttList,
  SearchSttListSummary
} from "@/domain/entities/ListCariSTT";
import { Pagination } from "@/domain/entities/Pagination";
import { AxiosResponse } from "axios";

export class CariSTTMapper {
  public convertListCariSTTFromApi(res: AxiosResponse<any>): CariSttEntities {
    const { data } = res;
    return new CariSttEntities(
      new Pagination(data.meta.page, data.meta.limit, data.meta.total_records),
      data.data.length
        ? data.data.map(
            (item: any) =>
              new ListCariSTT({
                manifestId: item.manifest_id,
                manifestNo: item.manifest_no,
                totalStt: item.total_stt,
                totalPieces: item.total_pieces,
                totalSttHanging: item.total_stt_hanging,
                createdAt: item.created_at,
                createdByUsername: item.created_by_username
              })
          )
        : []
    );
  }

  public convertSttPiecesSttDetailFromApi(
    res: AxiosResponse<any>
  ): DetailSttScan {
    const {
      data: { data }
    } = res;

    return new DetailSttScan({
      manifestId: data.manifest_id,
      manifestNo: data.manifest_no,
      partnerName: data.partner_name,
      partnerCity3lc: data.partner_city_3lc,
      partnerCityName: data.partner_city_name,
      totalStt: data?.total_stt,
      totalKoli: data?.total_koli,
      totalPieces: data?.total_pieces,
      totalSttHanging: data?.total_stt_hanging,
      totalKoliHanging: data?.total_koli_hanging,
      totalPiecesHanging: data?.total_pieces_hanging,
      createdAt: data?.created_at,
      createdByUsername: data?.created_by_username,
      sttList: data?.stt_list?.length
        ? data.stt_list.map(
            (item: any) =>
              new DetailStt({
                sttNo: item.stt_no,
                referenceNo: item.reference_no,
                shipmentType: item.shipment_type,
                lastStatus: item.last_status,
                hangingDays: item.hanging_days,
                hangingType: item.hanging_type,
                originCity3lc: item.origin_city_3lc,
                destinationCity3lc: item.destination_city_3lc
              })
          )
        : []
    });
  }

  public convertSearchSttScanDataFromApi(
    result: AxiosResponse<any>
  ): SearchSttScan {
    const {
      data: { data }
    } = result;

    return new SearchSttScan(convertSnakeToCamel({...data, pieces: data.total_pieces}));
  }

  public convertSearchSttManifestDataFromApi(
    result: AxiosResponse<any>
  ): DetailSttScan {
    const {
      data: { data }
    } = result;

    return new DetailSttScan({
      ...convertSnakeToCamel(data),
      partnerCity3lc: data.partner_city_3lc,
      sttList: data.stt_list?.length
        ? data.stt_list.map(
            (d: any) =>
              new DetailStt({
                ...convertSnakeToCamel(d),
                originCity3lc: d.origin_city_3lc,
                destinationCity3lc: d.destination_city_3lc
              })
          )
        : []
    });
  }

  public convertGetSearchSttScanListDataFromApi(
    result: AxiosResponse<any>
  ): SearchSttList {
    const { data } = result;

    return new SearchSttList({
      summary: new SearchSttListSummary(convertSnakeToCamel(data.summary)),
      data: data?.data?.length
        ? data.data.map((d: any) => new SearchSttScan(convertSnakeToCamel(d)))
        : []
    });
  }
}
